(ns rothko.editor.behaviours.space
  (:require [com.rpl.specter :as sp]
            [rothko.editor.actions :as actions]
            [rothko.editor.document.navigators :as n]
            [rothko.editor.matcher :as m]
            [rothko.editor.space.transform :as space-transform]
            [rothko.editor.edit.paths :as edit-paths]
            [rothko.editor.util :as util :include-macros true]))

(defn transform
  [{:keys [space-edits? keep-system-flag? chars] :or {chars " "} :as opts}]
  (let [new-token (-> (space-transform/new-token space-edits?)
                      (assoc :word chars))
        removable-space (space-transform/removable-space space-edits?)]
    [(sp/collect-one :selection)
     n/token-unbias
     (sp/multi-path
      (util/cond-path

       n/empty-document?
       [sp/DISPENSE
        actions/no-op]

       ;; Before a space token
       (n/and-paths
        (n/context? [m/?any m/?any (m/one-of [{:type :space} m/?any]
                                                 [{:type :space}])])
        n/end-of-token?)
       (sp/if-path
        (constantly space-edits?)
        (space-transform/insert 1 new-token)
        (sp/multi-path
         n/move-selection-one-char-to-right
         (n/selection-insert chars keep-system-flag?)))

       ;; After a space(-edit) token
       (n/and-paths
        (n/context? [(m/ends-with [{:type (m/one-of :space :space-edit) :edited? m/absent}]) m/?any m/?any])
        n/start-of-token?)
       (sp/multi-path
        n/move-selection-one-char-to-left
        (sp/if-path
         (constantly space-edits?)
         (space-transform/insert 1 new-token)
         (n/selection-insert chars keep-system-flag?))
        n/move-selection-one-char-to-right)

       ;; On a space token at the front or back
       (n/and-paths
        (n/context? [m/?any [{:type (m/one-of :space :space-edit) :edited? m/absent}] m/?any])
        (n/or-paths n/end-of-token? n/start-of-token?))
       (sp/if-path
        (constantly space-edits?)
        (space-transform/insert 1 new-token)
        (n/selection-insert chars keep-system-flag?))

       n/end-of-script?
       (sp/multi-path
        n/move-selection-one-char-to-right
        (space-transform/create new-token))

       n/start-of-script?
       (sp/multi-path
        (space-transform/create new-token)
        (n/expand-selection
         {:shift-start-offset -1
          :shift-end-offset -1}))

       (n/context? [m/?any [{:type removable-space :edited? m/absent}] m/?any])
       [(n/selection-insert chars keep-system-flag?)]

       (n/context? [m/?any (m/every (m/one-of {:type :edit} {:type removable-space :edited? m/absent})) m/?any])
       [(space-transform/edit-split new-token keep-system-flag?)]

       (n/and-paths
        (n/context? [m/?any [{:type :word}] (m/starts-with [{:type :word}])])
        n/end-of-token?)
       (sp/multi-path
        (n/expand-selection
         {:shift-start-index 1
          :shift-end-index 1})
        (space-transform/create new-token))

       (n/context?
        [m/?any
         (m/every (m/one-of {:type :word :edited? m/absent} {:type :space :edited? m/absent}))
         m/?any])
       [(edit-paths/create-from-selection chars opts)]

       ;; At the end of an edited word/space token
       (n/and-paths
        (let [allowed-type (if space-edits?
                             (m/one-of :word :space)
                             :word)]
          (n/context? [m/?any [{:type allowed-type :edited? true}] m/?any]))
        n/end-of-token?)
       (sp/multi-path
        n/move-selection-one-char-to-right
        (space-transform/create new-token)))
      n/token-rebias)]))
